import { Component, effect, inject, model, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucidePenLine,
  lucidePackage,
  lucideTrash2,
  lucideChevronLeft,
} from '@ng-icons/lucide';

import { CrudService } from '../../core/services/crud.service';
import { ColorTotalComponent } from '../../shared/components/color-total/color-total.component';
import { DecimalPipe, CurrencyPipe } from '@angular/common';
import { RollFormComponent } from '../roll-form/roll-form.component';

@Component({
  selector: 'app-roll-list',
  imports: [
    NgIcon,
    RollFormComponent,
    ColorTotalComponent,
    DecimalPipe,
    CurrencyPipe,
  ],
  viewProviders: [
    provideIcons({
      lucidePenLine,
      lucidePackage,
      lucideTrash2,
      lucideChevronLeft,
    }),
  ],

  templateUrl: './roll-list.component.html',
  styles: ``,
})
export class RollListComponent implements OnInit {
  private crudService = inject(CrudService);
  private router = inject(Router);

  productId = '';
  productName = '';
  productDescription = '';

  productRolls: Array<any> = [];

  existingRoll: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getRolls();
      }
    });
  }

  ngOnInit(): void {
    if (history.state) {
      this.productId = history.state.product.id;
      this.productName = history.state.product.name;
      this.productDescription = history.state.product.description;
      this.getRolls();
    } else {
      this.router.navigate(['/inventario']);
    }
  }

  openModal() {
    this.existingRoll = null;
    this.showModal.set(true);
  }

  getRolls() {
    this.crudService.getProductRollsByProductId(this.productId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.productRolls = response.body;
          // console.log(this.productRolls);
        }
      },
    });
  }

  updateRoll(roll: any) {
    this.existingRoll = roll;
    this.showModal.set(true);
  }

  deleteRoll(rollId: string) {
    this.crudService.deleteProductRoll(rollId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.getRolls();
        }
      },
    });
  }
}
